export default "__VITE_ASSET__DhR3zS6a__"